import { parse, stringify } from './urlHelpers';
import {
  GROUP_PAGE_TAB_ABOUT,
  GROUP_PAGE_TAB_DOCUMENTS,
  GROUP_PAGE_TAB_HIGHLIGHTS,
  GROUP_PAGE_TAB_MANAGE_MEMBERS,
  GROUP_PAGE_TAB_PAYMENTS,
  GROUP_PAGE_TAB_POSTS,
  GROUP_PAGE_VISIBLE_TABS,
} from './types';

const VALID_TABS = new Set([
  ...GROUP_PAGE_VISIBLE_TABS,
  GROUP_PAGE_TAB_MANAGE_MEMBERS,
]);

export const resolveGroupPageTab = search => {
  const { tab } = parse(search);
  if (tab && VALID_TABS.has(tab)) {
    return tab;
  }
  return GROUP_PAGE_TAB_POSTS;
};

export const buildGroupPageSearch = (currentSearch, tab) => {
  const params = parse(currentSearch);
  if (tab === GROUP_PAGE_TAB_POSTS) {
    delete params.tab;
  } else {
    params.tab = tab;
  }
  const search = stringify(params);
  return search ? `?${search}` : '';
};

export const getGroupIdFromParams = routeParams => routeParams?.id || routeParams?.groupId;

export const getGroupShareUrl = (slug, groupId, marketplaceRootUrl) => {
  const base = marketplaceRootUrl || process.env.REACT_APP_MARKETPLACE_ROOT_URL || '';
  const normalizedBase = base.replace(/\/$/, '');
  return `${normalizedBase}/feed-page/my-group-public/c/${slug || ''}/${groupId}`;
};
